import { graphql } from "@/types/gql";

export const QUERY_PERMIT_DECREE_LOCATIONS = graphql(`
  query PermitDecrees($permitDecreesInput: GetPermitDecreesInput!) {
    permitDecrees(permitDecreesInput: $permitDecreesInput) {
      id
      name
      done
      locations {
        id
        address {
          streetNumber
          streetName
          city
          postalCode
          province
          country
        }
        position
      }
    }
  }
`);

export const MUTATION_ADD_PERMIT_DECREE_LOCATION = graphql(`
  mutation AddPermitDecreeLocation($decreeId: String!, $location: PermitDecreeLocationInput!) {
    addPermitDecreeLocation(decreeId: $decreeId, location: $location) {
      id
    }
  }
`);

export const MUTATION_UPDATE_PERMIT_DECREE_LOCATION = graphql(`
  mutation UpdatePermitDecreeLocation($decreeId: String!, $location: PermitDecreeLocationInput!, $locationId: String!) {
    updatePermitDecreeLocation(decreeId: $decreeId, location: $location, locationId: $locationId) {
      id
    }
  }
`);

export const MUTATION_REMOVE_PERMIT_DECREE_LOCATION = graphql(`
  mutation RemovePermitDecreeLocation($decreeId: String!, $locationId: String!) {
    removePermitDecreeLocation(decreeId: $decreeId, locationId: $locationId) {
      id
      locations {
        id
        address {
          streetNumber
          streetName
          city
          postalCode
          province
          country
        }
        position
      }
    }
  }
`);
